import Repository from './Repository';
import { vue } from '../main';


const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/instance/member`;

export default {
  /**
   * Fetches the current member list of the active instance.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  list() {
    return Repository.get(`${base}/list`);
  },
  /**
   * Fetches the current member list of the active instance and pushes it to the store.
   *
   * @returns {Promise<T | never>}
   */
  refetchMemberList() {
    return this.list().then((response) => {
      vue.$store.commit('setInstanceMembers', response.data.list);
    });
  },
  /**
   * Adds the member to the specified group.
   *
   * @param name
   * @param groupId
   * @param description
   * @returns {Promise<AxiosResponse<T>>}
   */
  addMember(name, groupId, description = '') {
    return Repository.post(`${base}/add`, {
      name,
      gid: groupId,
      description,
    });
  },
  /**
   * Modifies the name and description of the given member.
   *
   * @param groupId
   * @param memberId
   * @param name
   * @param description
   * @returns {Promise<AxiosResponse<T>>}
   */
  editMember(groupId, memberId, name, description) {
    return Repository.post(`${base}/modify`, {
      gid: groupId,
      id: memberId,
      name,
      description,
    });
  },
  /**
   * Deletes the given member from the given group.
   *
   * @param groupId
   * @param memberId
   * @returns {Promise<AxiosResponse<T>>}
   */
  deleteMember(groupId, memberId) {
    return Repository.post(`${base}/delete`, {
      gid: groupId,
      id: memberId,
    });
  },
  /**
   * Moves the member from one group to another at a specified position.
   */
  moveMember(sourceGroupId, targetGroupId, memberId, position) {
    return Repository.post(`${base}/move`, {
      gid: sourceGroupId,
      target: targetGroupId,
      id: memberId,
      position: position,
    });
  },
};
